import type { Observability } from '~/lib/services/observability/types';

/** No-op fallback so callers never need to guard `useO11y()` with `?.`. */
const noopObservability: Observability<unknown> = {
  init: () => {},
  get isReady() {
    return false;
  },
  get sdk() {
    return undefined;
  },
  setUser: () => {},
  setTenant: () => {},
  reportError: () => {},
  trackAction: () => {},
};

/**
 * Composable to access the observability service in Vue components and composables.
 * Returns a no-op implementation when `$o11y` is not initialized, so it is always safe to call.
 */
export function useO11y(): Observability<unknown> {
  const nuxtApp = useNuxtApp();
  const o11y = nuxtApp.$o11y;

  if (!o11y) {
    console.warn('Observability service not initialized');
    return noopObservability;
  }

  return o11y;
}
